export default __webpack_public_path__ + "static/media/bgm-2.3ce00ea8.webp";